import "../styles/genAIJobRoles.css";
import {
  FaCloud,
  FaUserCog,
  FaTools,
  FaNetworkWired,
  FaShieldAlt,
  FaServer
} from "react-icons/fa";

export default function CloudJobRoles() {
  const roles = [
    { title: "Cloud Engineer", icon: <FaCloud /> },
    { title: "AWS Cloud Administrator", icon: <FaUserCog /> },
    { title: "DevOps / Cloud Support Engineer", icon: <FaTools /> },
    { title: "Cloud Solutions Associate", icon: <FaNetworkWired /> },
    { title: "Junior Cloud Architect", icon: <FaServer /> },
    { title: "AWS Security Engineer", icon: <FaShieldAlt /> }
  ];

  return (
    <section className="genai-roles-page">
      <div className="roles-container">
        <div className="roles-header">
          <h2>
            Program Key <span>Job Roles</span>
          </h2>
          <p>Career opportunities after completing the Cloud Computing Program</p>
        </div>

        <div className="roles-grid">
          {roles.map((role, index) => (
            <div className="role-card" key={index}>
              <div className="role-icon">{role.icon}</div>
              <h4>{role.title}</h4>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
